import { createSlice } from '@reduxjs/toolkit';
import { getFeatureControlApi } from '../../../rtk-apis/clinics/getFeatureControl';

const initialState = {
  status: '',
  result: null as any,
  msg: '',
  loading: false,
};

const getFeatureControlSlice = createSlice({
  name: 'getFeatureControl',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.result = null;
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getFeatureControlApi.pending, state => {
        state.loading = true;
      })
      .addCase(getFeatureControlApi.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.result = action?.payload;
        state.msg = (action?.payload as any)?.msg || '';
      })
      .addCase(getFeatureControlApi.rejected, (state, action) => {
        state.loading = false;
        state.status = 'ERROR';
        state.result = null;
        state.msg = (action?.payload as string) || 'Something went wrong!';
      });
  },
});

export default getFeatureControlSlice.reducer;
export const { clearState } = getFeatureControlSlice.actions;
